import Container from '@/container';
import {Row, Col} from '@/grid';
import {Grid} from '@/content/features/shared';
import {withMarginBottomZeroToSm} from '@/hocs/withSpacing';
import Link from '@/links';
import {SectionPaddingHalfBottom, SectionPaddingHalfTop} from '@/section';
import {H1, P} from '@/typography';
import {withHomeSubP} from '@/hocs/withFontType';
import {withGreen800} from '@/hocs/withColors';
import {useTranslations} from 'next-intl';
import styles from './styles.module.scss';

const H1Green800 = withGreen800(H1);
const SubP = withHomeSubP(P);
const CtaDefaultMarginedMob = withMarginBottomZeroToSm(Link);

const HeroSection = () => {
  const t = useTranslations('features.hero');
  const sharedT = useTranslations('shared');

  return (
    <SectionPaddingHalfBottom>
      <Container variant="section-padding-below-nav">
        <SectionPaddingHalfTop>
          <Grid fluid>
            <Row center="xs">
              <Col xs={12} lg={8}>
                <H1Green800>{t('title')}</H1Green800>
                <SubP>{t('subtitle')}</SubP>
              </Col>
            </Row>
            <Row center="xs">
              <Col xs={12} lg={6}>
                <ul className={styles['list-inline-to-bl']}>
                  <li>
                    <CtaDefaultMarginedMob
                      href="/demo"
                      variant="cta-default-xs"
                      customAttributes={{
                        'data-gtm': 'features-hero-demo',
                        'data-ui': 'features-hero-demo'
                      }}>
                      {sharedT('demoCTALabel')}
                    </CtaDefaultMarginedMob>
                  </li>
                  <li>
                    <Link
                      href="/free-trial"
                      variant="primary"
                      customAttributes={{
                        'data-gtm': 'features-hero-free-trial',
                        'data-ui': 'features-hero-free-trial'
                      }}>
                      {sharedT('freeTrialCTALabel')}
                    </Link>
                  </li>
                </ul>
              </Col>
            </Row>
          </Grid>
        </SectionPaddingHalfTop>
      </Container>
    </SectionPaddingHalfBottom>
  );
};

export default HeroSection;
